import { render, staticRenderFns } from "./EbpmsLineChart.vue?vue&type=template&id=24c4a649"
import script from "./EbpmsLineChart.vue?vue&type=script&lang=js"
export * from "./EbpmsLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports